import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { CUSTOM_ELEMENT_DEFAULT, NEWSPAPER_DATA, PROGRAM_CLI_MOVIES_ITEMS } from '../../../constants/state'
import EditNewspaperElement from '../../PageEditItem/present/EditNewspaperElement'
import { addNewspaperItem, printDataUpdateRequest, updateNewspaperItem } from '../../../actions'
import getData from '../../../functions/getData'
import getMovieSortedByTitle from '../../../functions/getMoviesSortedByTitle'
import { CUSTOMITEMS } from '../../../constants/itemTypes'

const mapDispatchToProps = (dispatch, ownProps) => ({
    updateNewspaperItem: (item) => {
        dispatch(updateNewspaperItem(CUSTOMITEMS, item))
        dispatch(printDataUpdateRequest())
    }
})

const mapStateToProps = state => ({
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    newspaperData: getData(state, NEWSPAPER_DATA)
})

const EditCustomItemsContainer = ({updateNewspaperItem, itemId, closePagePath, cinemaId, movieData, newspaperData}) => {
    const itemData = newspaperData.customItems.items ? newspaperData.customItems.items[itemId] : null

    return (
        <EditNewspaperElement
            closePagePath={closePagePath}
            cinemaId={cinemaId}
            itemId={itemId}
            movieData={movieData}
            itemData={itemData}
            onUpdateItem={updateNewspaperItem}
            sortedMovieDataKeys={getMovieSortedByTitle(movieData)}
        />
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditCustomItemsContainer)